import * as helpers from '../helpers';
import l10n from '../lang/locallang';

/**
 * Add to external link the mention 'alt + (External link)'
 * Add to blank link the mention 'alt + (New window)', and the rel noreferrer, noopener
 * Add to external and blank link the mention 'alt + (New window External link)', and the rel noreferrer, noopener
 */
export default function linkExternalNewWindow() {
    // Get anchors and filter them
    let anchors = Array.prototype.slice.call(document.querySelectorAll('body a'));
    const noIconFor = new RegExp('(tel:|mailto:|facebook.com|instagram.com|linkedin.com|youtube.com|twitter.com)');

    // Skip if anchor has .new-window-off, .tooltip-svg or .no-external classes
    anchors = anchors.filter(anchor => !helpers.hasClass(anchor, ['new-window-off', 'tooltip-svg', 'no-external']));

    // Skip if anchor has 'data-fancybox attribute
    anchors = anchors.filter(anchor => !anchor.hasAttribute('data-fancybox'));

    // Add rel noopener to element
    const addRelNoopener = (elem) => {
        const elemRel = elem.hasAttribute('rel') && elem.getAttribute('rel');
        if (elemRel) {
            if (elemRel.split(' ').indexOf('noopener') < 0) {
                elem.setAttribute('rel', `${elemRel} noopener`);
            }
        } else {
            elem.setAttribute('rel', 'noopener');
        }
    };

    // Add aria-label to element
    const getAlt = (elem) => {
        const title = elem.getAttribute('title');
        const ariaLabel = elem.getAttribute('aria-label');
        let text;

        if (title) {
            text = title;
            elem.removeAttribute('title');
        } else if (ariaLabel) {
            text = ariaLabel;
        } else {
            const textArray = [];
            const elemChildren = Array.prototype.slice.call(elem.childNodes);

            elemChildren.forEach((child) => {
                if (child.nodeName === 'IMG') {
                    textArray.push(child.alt);
                } else if (child.nodeName === 'PICTURE') {
                    const pictureChildren = [].slice.call(child.querySelectorAll('*'));
                    pictureChildren.forEach((child2) => {
                        if (child2.nodeName === 'IMG') {
                            textArray.push(child2.alt);
                        }
                    });
                } else if (child.nodeName === '#text') {
                    textArray.push(child.textContent.trim().toLowerCase());
                } else if (child.nodeName === 'svg') {
                    textArray.push(child.getAttribute('aria-label'));
                } else {
                    textArray.push(child.textContent.trim().toLowerCase());
                }
            });

            text = textArray.join(' ');
        }
        return text;
    };

    const domain = document.querySelector('.site-wrapper').getAttribute('data-domain');

    const direct = document.querySelector('.location__map-figure');
    if (!direct) {
        // Main loop
        anchors.forEach((anchor) => {
            if ((anchor.hostname.indexOf(domain) !== -1 || anchor.hostname === location.hostname) && helpers.hasClass(anchor, 'js-page-detail')) {
                anchor.setAttribute('title', `${getAlt(anchor)}`);
            } else if (anchor.hostname !== location.hostname && anchor.getAttribute('target') !== '_blank') { // If external link but not _blank
                anchor.setAttribute('title', `${getAlt(anchor)} (${l10n.linkExternalLink})`);
                helpers.addClass(anchor, 'link-external');
            } else if (anchor.hostname !== location.hostname && anchor.getAttribute('target') === '_blank') { // If external link and _blank
                anchor.setAttribute('title', `${getAlt(anchor)} (${l10n.linkNewWindow})`);
                addRelNoopener(anchor);
                helpers.addClass(anchor, 'link-external');
            } else if (anchor.hostname === location.hostname && anchor.getAttribute('target') === '_blank') { // If internal and blank
                anchor.setAttribute('title', `${getAlt(anchor)} (${l10n.linkNewWindow})`);
                addRelNoopener(anchor);
            }

            if (anchor.href.indexOf('linkTo_UnCryptMailto') !== -1) {
                anchor.removeAttribute('target');
            }

            // Add .no-external-icon for tel, mail and social networks anchors
            if (noIconFor.test(anchor.getAttribute('href'))) {
                helpers.addClass(anchor, 'no-external-icon');
            }
        });
    }
}
